import { Injectable } from '@angular/core';
import {CommonService} from './common.service';

@Injectable({
  providedIn: 'root'
})
export class AutomationsService {
  constructor(private commonService: CommonService) { }

  async fetchCommandTypes() {
    return await this.commonService.getSimpleList(`automation/command_types`);
  }

  async fetchTypes() {
    return await this.commonService.getSimpleList(`automation/types`);
  }

  async fetchAutomationsByType(typeId: any) {
    return await this.commonService.getSimpleList(`automation?type_id=${typeId}`);
  }

  async fetchEmails() {
    return await this.commonService.getSimpleList(`automation/emails`);
  }

  async insertEmailToList(model: any) {
    return await this.commonService.insertObjectForAutomations(`automation/email` , model);
  }

  async removeEmailFromList(id: number) {
    return await this.commonService.deleteRecord(`automation/email/${id}`);
  }

  async fetchUsersForNotification() {
    return await this.commonService.getSimpleList(`automation/notification`);
  }

  async insertUserToList(model: any) {
    return await this.commonService.insertObjectForAutomations(`automation/notification` , model);
  }

  async removeUserFromList(id: number) {
    return await this.commonService.deleteRecord(`automation/notification/${id}`);
  }
}
